import React, { useCallback, useRef } from "react";

import { getAnalytics } from "@tm/insurance/analytics";
import { trackComponentView } from "@tm/insurance/analytics/xdm";
import { PARTNER } from "@tm/isomorphic-utils";
import {
  FlexComp,
  H2Tag,
  H5Tag,
  ImageComponent,
  ParaTag,
  SpanTag,
} from "@tm/static";
import { usePartnerContext } from "@tm/static/partnerContext";
import { useBreakpointV2 } from "@tm/ui-widgets";
import {
  IntersectionObserverData,
  useIntersectionObserver,
} from "@tm/ui/hooks";
import { theme } from "@tm/utility/global";
import { InnerContentWrap } from "../../CommonStyle/CommonStyles.style";
import FormattedText, { TextNodeType } from "../FormattedText/FormattedText";
import {
  ShieldWrap,
  WhyBuyItem,
  WhyBuyTravInsStyle,
  WhyFeatListWrap,
} from "./WhyBuyTravIns.style";

interface WhyBuyTravInsInterFace {
  title?: TextNodeType;
  info?: TextNodeType;
  data: {
    icon: string;
    info: TextNodeType;
  }[];
}

const WhyBuyTravIns: React.FC<WhyBuyTravInsInterFace> = ({
  title,
  info,
  data,
}) => {
  const device = useBreakpointV2();
  const context = usePartnerContext();
  const analytics = getAnalytics();
  const hasTracked = useRef<boolean>(false);

  // Track component view when it comes into viewport
  const handleIntersection = useCallback((data: IntersectionObserverData) => {
    trackComponentView({
      name: "section_1_shown",
      type: "card",
    });
    if (!hasTracked.current) {
      analytics?.trackLandingEvents({
        actionType: "why_buy_trav_ins_seen",
      });
    }
    hasTracked.current = true;
  }, []);

  const { ref: intersectionRef } = useIntersectionObserver(handleIntersection, {
    threshold: 0.5, // Trigger when 50% of component is visible
    // triggerOnce: true, // Only track once per component mount
    triggerOnLeaveViewport: true,
  });

  return (
    <WhyBuyTravInsStyle ref={intersectionRef}>
      <InnerContentWrap>
        <FlexComp
          // flexWrap="wrap"
          flexDirection={device == "lg" ? "row" : "column"}
          alignItems="center"
          gap={
            device == "lg"
              ? context === PARTNER.MYBIZ
                ? "10px"
                : "74px"
              : "24px"
          }
        >
          <div>
            {device == "lg" ? (
              <H2Tag margin="0 0 60px">
                {title && <FormattedText value={title} />}
              </H2Tag>
            ) : (
              <H5Tag margin="0 0 20px">
                {" "}
                {title && <FormattedText value={title} />}
              </H5Tag>
            )}
            <ParaTag
              fontSize={device == "lg" ? "large" : "sm"}
              color={theme.greyText}
            >
              {info && <FormattedText value={info} />}
            </ParaTag>
          </div>
          <WhyFeatListWrap>
            {data &&
              data.map((item, index) => {
                return (
                  <WhyBuyItem key={index}>
                    {item.icon && (
                      <ImageComponent src={item.icon} height="24" width="24" />
                    )}
                    <SpanTag>
                      <FormattedText value={item?.info} />
                    </SpanTag>
                  </WhyBuyItem>
                );
              })}
          </WhyFeatListWrap>
          {device == "lg" && (
            <ShieldWrap>
              <ImageComponent
                width="286px"
                height="320px"
                src="https://tripmoneycmsimgak.mmtcdn.com/img/Light_Green_Shield_5cb1aff4ce.svg"
              />
            </ShieldWrap>
          )}
        </FlexComp>
      </InnerContentWrap>
    </WhyBuyTravInsStyle>
  );
};

export default WhyBuyTravIns;
